import { render, staticRenderFns } from "./GestaoCertificacao.vue?vue&type=template&id=07db7db7&lang=pug"
import script from "./GestaoCertificacao.vue?vue&type=script&lang=js"
export * from "./GestaoCertificacao.vue?vue&type=script&lang=js"
import style0 from "./GestaoCertificacao.vue?vue&type=style&index=0&id=07db7db7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports